import { Observable } from 'rxjs';

import { Deviation } from '../models/deviation.model';

export abstract class DeviationGateway {
  abstract listDeviations(): Observable<Deviation[]>;
}
